import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'


const btnCloseDetails = document.getElementById('closeDetails')
const backgroundText = document.querySelector('.backgroundText')
const titles = document.querySelectorAll('.slideshow-list  .title');
const details = document.querySelectorAll('.detail-view__content');

let lastScroll = 0;

export const displayDetails = (i, open) => {

    if (open) {
        // lastScroll = window.scrollY;
        // ScrollTrigger.getById(1).disable();
        gsap.fromTo(btnCloseDetails, { opacity: 0 }, { delay: 1.2, duration: 0.4, opacity: 1, display: 'block' })
        gsap.to('.progressScroll', {opacity: 0, duration: 0.4})
        gsap.to(details[i], {opacity: 1, delay: 1.2, duration: 0.4, display: 'block'});
        gsap.to(backgroundText, {opacity:0, delay: 1, duration: 0.4 })  
        gsap.to('.detail-view', {display: 'block'})
        
        for (const title of titles) {
            gsap.to(title, { duration: 0.4, opacity: 0})
        }
        
    } else {
        // ScrollTrigger.getById(1).scroll(lastScroll);
        // ScrollTrigger.getById(1).enable();
        gsap.to(btnCloseDetails, { duration: 0.4, opacity: 0.5, display: "none" })
        gsap.to(details[i], {opacity: 0, duration: 0.4, display: 'none'});
        gsap.to(backgroundText, {opacity:1, delay: 0.5, duration: 0.4 })
        gsap.to('.detail-view', {display: 'none'})
        
        setTimeout(() => {
            gsap.to('.title', { duration: 0.4, opacity: 1})
            gsap.to('.progressScroll', {opacity: 1, duration: 0.4})
        }, 1000)
    }
}




